module.exports = __webpack_public_path__ + "img/category_huonekalut.27505f97.webp";